window.cookieStorage = (options = { path: '/', secure: true }) => {
  return {
    getItem(key) {
      let cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].split('=')
        if (key == cookie[0].trim()) {
          return decodeURIComponent(cookie[1])
        }
      }
      return null
    },
    setItem(key, value) {
      document.cookie = Object.entries({
        path: '/',
        secure: true,
        sameSite: 'strict',
        ...options,
      }).reduce((acc, [name, value]) => {
        return value === false
          ? acc
          : `${acc};${name}=${
              value === true ? 'true' : value === false ? '' : value
            }`
      }, `${key}=${encodeURIComponent(value)}`)
    },
  }
}
